import Vue from 'vue'
import Vuex from 'vuex'

import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: false,

    settings: {
      lang: localStorage.getItem('lang') || 'tc',
      refreshInterval: JSON.parse(localStorage.getItem('refreshInterval')) || 300000, //5mins
      location: localStorage.getItem('location') || '京士柏'
    },

    weatherReport: {
      temperatureArray: [],
      weatherIconArray: [],
      humidity: [],
      lastUpdate: '',
      isLoading: false
    },

    weatherForecast: {
      forecastArray: [],
      lastUpdate: '',
      isLoading: true
    },

    warning: {
      warningArray: [],
      isLoading: false
    }
  },
  mutations: {
    mutateSettingsLocation(state, location){
      state.settings.location = location;
    },
    mutateSettingsLang(state, lang){
      state.settings.lang = lang;
    },
    mutateSettingsRefresh(state, refresh){
      state.settings.refreshInterval = refresh;
    },
    mutateWeatherForecast(state, array){
      state.weatherForecast = array;
    },
    updateWeatherReport(state, raw){
      state.weatherReport.temperatureArray = raw.temperature.data;
      state.weatherReport.weatherIconArray = raw.icon;
      state.weatherReport.humidity = raw.humidity.data[0].value;
      state.weatherReport.lastUpdate = raw.updateTime;
    },
    updateWeatherForecast(state, raw){
      state.weatherForecast.forecastArray = raw.weatherForecast;
      state.weatherForecast.lastUpdate = raw.updateTime;
    },
    updateWarning(state, raw){
      state.warning.warningArray = raw;
    },
    mutateWeatherReportIsLoading(state, boolean){
      state.weatherReport.isLoading = boolean;
    },
    mutateWeatherForecastIsLoading(state, boolean){
      state.weatherForecast.isLoading = boolean;
    },
    mutateWarningIsLoading(state, boolean){
      state.warning.isLoading = boolean;
    }

  },
  actions: {
    fetchWeatherReport({state, commit}){
      console.log(new Date + ' fetching...')
      commit('mutateWeatherReportIsLoading', true)
      axios.get('rhrread&lang=' + state.settings.lang ).then(
        res => {
          commit('updateWeatherReport', res.data)
        }
      ).catch().finally(
        ()=>{
          commit('mutateWeatherReportIsLoading', false)
        }
      )
    },
    fetchWeatherForecast({state, commit}){
      console.log(new Date + ' fetching...')
      commit('mutateWeatherForecastIsLoading', true)
      axios.get('fnd&lang=' + state.settings.lang ).then(
        res => {
          commit('updateWeatherForecast', res.data)
        }
      ).catch().finally(
        ()=>{
          commit('mutateWeatherForecastIsLoading', false)
        }
      )
    },
    fetchWarning({state, commit}){
      console.log(new Date + ' fetching...')
      commit('mutateWarningIsLoading', true)
      axios.get('warnsum&lang=' + state.settings.lang ).then(
        res => {
          commit('updateWarning', res.data)
        }
      ).catch().finally(
        ()=>{
          commit('mutateWeatherForecastIsLoading', false)
        }
      )
    }
  }
})
